import { HandySvg } from "handy-svg";
import { useRef, useState } from "react";
import useClickOutside from "../../../utils/hooks/useClickOutside";
import * as ga from "../../../lib/ga";

const aspectRatio = [
	{ name: "(1:1)", value: "1:1", dictionaryKey: "square", icon: "1x1" },
	{ name: "(16:9)", value: "16:9", dictionaryKey: "widescreen", icon: "16x9" },
	{ name: "(9:16)", value: "9:16", dictionaryKey: "mobile", icon: "9x16" },
	{ name: "(3:2)", value: "3:2", dictionaryKey: "landscape", icon: "3x2" },
	{ name: "(4:5)", value: "4:5", dictionaryKey: "portrait", icon: "4x5" },
];

const AspectRatio = ({ style, activeItem, dictionary, isLoading, changeSettings }) => {
	const [listISOpen, setListISOpen] = useState(false);
	const itemRef = useRef(null);

	const gaAspectRatio = (name) => {
		ga.event({
			action: `TextToImg page: aspect ratio`,
			params: { event_label: name },
		});
	};

	const listClose = () => setListISOpen(false);

	const listToggle = () => setListISOpen(!listISOpen);

	const selectItem = (item) => {
		listClose(false);
		gaAspectRatio(item.dictionaryKey);
		changeSettings(item, "aspect_ratio");
	};

	useClickOutside(itemRef, listClose);

	return (
		<div ref={itemRef} className={style[`settings-default-item`]}>
			<p className={style[`title`]}>{dictionary["aspect_ratio"] || "Aspect ratio"}</p>
			<button id="aspect-ratio-toggle" className={style[`default-btn`]} disabled={isLoading} onClick={listToggle}>
				{`${dictionary[activeItem.dictionaryKey]} ${activeItem.value}`}
				<HandySvg src={"/workspace/profile/profile_arrow.svg"} width={13} height={8} className={style.icon} />
			</button>
			<div id="ratio-list" className={`${style["drop-down-list"]} ${listISOpen ? style["open"] : style["close"]}`}>
				{aspectRatio.map((item, index) => {
					if (index === 1) {
						<button
							id="aspect-btn"
							className={`${style["drop-down-list_item"]} ${item.value === activeItem.value ? style["active"] : style["no-active"]}`}
							key={index}
							onClick={() => selectItem(item)}
						>
							<HandySvg className={style["crop-ico"]} src={`/image_editor/controls/adjust/crop/${item.icon}.svg`} width="45" height="45" />
							<p>
								<span>{dictionary[item.dictionaryKey]}</span> <span>(</span>
								{item.value}
								<span>)</span>
							</p>
						</button>;
					}
					return (
						<button className={`${style["drop-down-list_item"]} ${item.value === activeItem.value ? style["active"] : style["no-active"]}`} key={index} onClick={() => selectItem(item)}>
							<HandySvg className={style["crop-ico"]} src={`/image_editor/controls/adjust/crop/${item.icon}.svg`} width="45" height="45" />
							<p>
								<span>{dictionary[item.dictionaryKey]}</span> <span>(</span>
								{item.value}
								<span>)</span>
							</p>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default AspectRatio;
